import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const societyStatus = createAsyncThunk("societyStatus", async (id) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.put(
      `${API_KEY}/api/society/status/${id.societyID}`,
      { status: id.status ? id.status : "" },
      {
        headers: { Authorization: `Barear ${token}` },
        "Content-Type": "application/json",
      }
    );

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  societyStatusData: null,
  isError: false,
  errorMessage: "",
};
const societyStatusSlice = createSlice({
  name: "societyStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(societyStatus.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(societyStatus.fulfilled, (state, action) => {
      state.isLoading = false;
      state.societyStatusData = action.payload;
    });
    builder.addCase(societyStatus.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default societyStatusSlice.reducer;
